export default function save() {
	return null; // Server-side rendered
}
